import { render, staticRenderFns } from "./CancelDetail.vue?vue&type=template&id=049b2b2a&"
import script from "./CancelDetail.vue?vue&type=script&lang=js&"
export * from "./CancelDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports